import PropTypes from 'prop-types';
import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from 'styled-components';
import { connect, Provider } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { generateTheme } from 'ravenjs';

import AppNav from 'components/AppNav';
import Routes from 'containers/Routes';
import { selectors as brandingSelectors } from 'modules/branding';

/**
 * The main Root component for the application.
 *
 * @method      Root
 * @param       {Object} history   The react-router history object
 * @param       {Object} persistor The redux-persist persistor object
 * @param       {Object} store     The redux store
 * @param       {Object} theme     The styled-components theme object
 * @constructor
 */
function Root({ history, persistor, store, theme }) {
    return (
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                <ConnectedRouter history={history}>
                    <ThemeProvider theme={generateTheme(theme)}>
                        <div>
                            <AppNav />
                            <Routes />
                        </div>
                    </ThemeProvider>
                </ConnectedRouter>
            </PersistGate>
        </Provider>
    );
}

Root.propTypes = {
    history  : PropTypes.object.isRequired,
    persistor: PropTypes.object.isRequired,
    store    : PropTypes.object.isRequired,
    theme    : PropTypes.object.isRequired
};

Root.defaultProps = {};

const mapStateToProps = createStructuredSelector({
    theme: brandingSelectors.getTheme
});

export default connect(mapStateToProps)(Root);
